import React from 'react'
const reasons = [
	{
		title: 'Usnadňuje nákup: první i opakovaný',
		description: (
			<>
				{' '}
				Výběr i potvrzení objednávky je v aplikaci rychlý a pohodlný.
				U opakovaného nákupu trvá několik desítek vteřin. Zákazník nakoupí bez
				registrace, bez přihlášení, dokonce bez použití klávesnice.{' '}
				<b>Aplikace mu údaje v košíku předvyplní sama. </b>{' '}
			</>
		),
		index: '/img/icons/how-it-works-1.svg',
	},
	{
		title: 'Zkracuje cestu ke zboží na 1 kliknutí ',
		description: (
			<>
				​O novém zboží, výprodeji a dalších přínosných informacích{' '}
				<b>se uživatel aplikace dozvídá tou nejjednodušší cestou: </b> přímo
				z plochy svého telefonu. Aplikace mu rozešle notifikaci, která ho na
				kliknutí zavede rovnou k požadovanému sdělení. Sám nic dohledávat
				nemusí: ani na sítích, ani v e-mailu.
			</>
		),
		index: '/img/icons/how-it-works-2.svg',
	},
	{
		title: 'Rychlejší než web',
		description: (
			<>
				Díky využívaným technologiím se tyto weby načítají mnohem rychleji, což
				je extrémně klíčové, jelikož{' '}
				<b>
					mobilní aplikace zabírají 56 %, který uživatelé tráví na internetu.
				</b>{' '}
			</>
		),
		index: '/img/icons/how-it-works-3.svg',
	},
	{
		title: 'Umožňuje využít další chytré funkce',
		description: (
			<>
				​Aplikace využívá{' '}
				<b>schopnosti telefonů, aby uživateli nákup ještě více zpříjemnil.</b>{' '}
				Při recenzování zboží nebo scanování čárových kódů umožňuje využít
				fotoaparát. Během výběru odběrného místa třeba se Zásilkovnou přehledně
				nabízí nejbližší pobočky. Také dokáže jedním kliknutím spustit navigaci.
			</>
		),
		index: '/img/icons/how-it-works-4.svg',
	},
]

const ReasonsForApp = () => {
	return (
		<div className="mb-28">
			<h2 className="mb-12 text-center text-3xl font-bold">
				4 důvody, proč zákazníci nakupují radši v aplikaci
			</h2>
			<div className="mx-8 grid grid-rows-4 gap-x-8 gap-y-10 md:mx-20 md:grid-cols-2 md:grid-rows-2">
				{reasons.map(reason => (
					<ReasonsCard
						key={reason.index}
						title={reason.title}
						description={reason.description}
						index={reason.index}
					/>
				))}
			</div>
		</div>
	)
}

const ReasonsCard = ({
	title,
	description,
	index,
}: {
	title: string
	description: React.ReactNode
	index: string
}) => {
	return (
		<div className="flex flex-col items-center justify-center gap-8 rounded-2xl bg-white p-8 shadow-custom md:flex-row">
			<img src={index} alt={index} width={64} height={64} />
			<div>
				<h3 className="mb-4 text-center text-lg font-bold md:text-left">
					{title}
				</h3>
				<p className="text-center md:text-left">{description}</p>
			</div>
		</div>
	)
}
export default ReasonsForApp
